const ServiceData = [
        {
          id:"is1",
          icon:"fas fa-window-restore",
          title: "Modern and intuitive user interface",
          text: "Built and designed from the ground up for simplistic document workflows.",
          iconBackground:"#0052cc", 
          description: "Built and designed from the ground up for simplistic document workflows."
        },
        {
          id:"is2",
          icon:"fas fa-file-alt",
          title: "Streamlined document collection",
          text:"Quickly send document collection requests using pre-defined customisable templates.",
          iconBackground:"#0052cc", 
          description: "Quickly send document collection requests using pre-defined customisable templates."
        },
        {
          id:"is3",
          icon:"fas fa-hdd",
          title: "Electronic document signing",
          text: "Connect and automate your entire agreement process.",
          iconBackground:"#0052cc", 
          description: "Connect and automate your entire agreement process."
        },
        {
          id:"is4",
          icon:"fas fa-shield-alt",
          title: "Secure and reliable document sharing",
          text: "Shared files containing personal information will be protected from an unintended recipient with our password protected feature.",
          iconBackground:"#0052cc", 
          description: "Shared files containing personal information will be protected from an unintended recipient with our passpord protected feature."
        },
        {
          id:"is5",
          icon:"fas fa-robot",
          title: "Powerful document & business analytics",
          text:"Analytics and summaries can be produced by AI in a matter of seconds.",
          iconBackground:"#0052cc", 
          description: "Analytics and summaries can be produced by AI in a matter of seconds."
        },
        {
          id:"is6",
          icon:"fas fa-check",
          title: "Automate fact find through document AI",
          text:"Convert documents into data, insights and actions.",
          iconBackground:"#0052cc", 
          description: "Convert documents into data, insights and actions."
        },
        {
          id:"is7",
          icon:"fas fa-chart-line",
          title:"Document verification",
          text:"Documents will be parsed and cross checked by our AI service.",
          iconBackground:"#0052cc", 
          description: "Documents will be parsed and cross checked by our AI service."
        },
        {
          id:"is7",
          icon:"fas fa-hourglass",
          title:"Smart document search",
          text:"Natural language based document searching using AI.",
          iconBackground:"#0052cc", 
          description: "Natural language based document searching using AI."
        },
    ]
  export default ServiceData;